/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', function() {
    // Identifica o botão de checkout dinâmico
    var checkoutButton = document.querySelector('.shopify-payment-button');

    // Função para verificar se todos os campos obrigatórios estão preenchidos
    function checkRequiredFields() {
        var requiredFields = document.querySelectorAll('.personalization-input[required]');
        var allFieldsFilled = true;

        requiredFields.forEach(function(field) {
            if (field.type === 'file') {
                // Para campos de arquivo, verifica se um arquivo foi selecionado
                if (field.files.length === 0) {
                    allFieldsFilled = false;
                }
            } else if (field.type === 'checkbox' || field.type === 'radio') {
                // Para checkboxes e radio buttons, verifica se pelo menos um está selecionado
                var group = document.querySelectorAll(`input[name="${field.name}"]:checked`);
                if (group.length === 0) {
                    allFieldsFilled = false;
                }
            } else if (field.value.trim() === '') {
                allFieldsFilled = false;
            }
        });

        // Habilita ou desabilita o botão de checkout dinâmico
        if (allFieldsFilled) {
            checkoutButton.style.pointerEvents = 'auto';
            checkoutButton.style.opacity = '1';
        } else {
            checkoutButton.style.pointerEvents = 'none';
            checkoutButton.style.opacity = '0.5';
        }
    }

    // Adiciona o evento de verificação aos campos obrigatórios
    var requiredFields = document.querySelectorAll('.personalization-input[required]');
    requiredFields.forEach(function(field) {
        field.addEventListener('input', checkRequiredFields);
        if (field.type === 'file') {
            field.addEventListener('change', checkRequiredFields);
        }
    });

    // Inicializa a verificação ao carregar a página
    checkRequiredFields();
});